import { Component, Input, inject } from '@angular/core';
import { Patient } from 'app/core/models/patient.model';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { UserRoleName } from '../../../core/enums/user-role-name.enum';
import { PatientNavComponent } from '../patient-nav/patient-nav.component';
import { PatientDeactivateButtonComponent } from '../patient-deactivate-button/patient-deactivate-button.component';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BlankValueDashComponent } from '../../../shared/components/blank-value-dash/blank-value-dash.component';
import { ClientNameComponent } from '../../../shared/components/client-name/client-name.component';

@Component({
    selector: 'app-patient-header',
    templateUrl: './patient-header.component.html',
    styleUrls: ['./patient-header.component.scss'],
    imports: [PatientNavComponent,
              PatientDeactivateButtonComponent,
              RouterLink,
              BlankValueDashComponent,
              ClientNameComponent,
              DatePipe]
})
export class PatientHeaderComponent {
  private authService = inject(AuthenticationService);

  @Input() patient: Patient;

  public get active(): boolean {
    return this.patient && this.patient.inactiveDate === null;
  }

  public get healthGorillaActive(): boolean {
    const clientEnabled = this.patient.client.healthGorillaSettings?.enabled;
    const userAllowed = this.authService.hasPermissionTo(UserRoleName.accessHieData);

    return clientEnabled && userAllowed
  }

  onPatientDeactivated(_patient: Patient) {
    location.reload();
  }
}
